<template>
    <div class="col-12">
        <span><strong>{{fieldKey | capitalize}}:</strong></span>
        <span v-if="$utils.isPrimitive(field)">{{field}}</span>
        <div v-for="(meta, metaKey) in field"  v-else>
            <api-endpoint-route-field  :field="meta" :field-key="metaKey"/>
        </div>
    </div>
</template>
<script>
import CphFilters from '../../../../mixins/CphFilters';
export default {
    name: 'api-endpoint-route-field',
    props: {
        field: {},
        fieldKey: {}
    },
    mixins: [CphFilters]
};
</script>
